import styled from "styled-components";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { fadeInUp } from "./Animations.styles";

export const TimerSection = styled.div`
    background: rgba(255, 255, 255, 0.95);
    padding: 10px;
    border-radius: 8px;
    border: none;
    margin-bottom: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s;
    animation: ${fadeInUp} 0.55s ease-out;

    &:hover {
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }
`;

export const TimerTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin-bottom: 8px;
    padding: 4px;
    border-radius: 2px;
    transition: background 0.2s;

    &:hover {
        background: rgba(156, 163, 175, 0.1);
    }
`;

export const TitleWithIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        color: #4b5563;
        font-size: 16px;
    }
`;

export const TimerToggleIcon = styled(ExpandMoreIcon)`
    color: #666666;
    font-size: 18px !important;
    transition: transform 0.3s ease;
    transform: ${(props) =>
        props.expanded ? "rotate(180deg)" : "rotate(0deg)"};
`;

export const TimerContentContainer = styled.div`
    max-height: ${(props) => (props.expanded ? "500px" : "0")};
    overflow: hidden;
    transition: max-height 0.3s ease-out;
`;

export const TimerDisplay = styled.div`
    background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
    border: 2px solid #e5e7eb;
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    margin-bottom: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const TimerTime = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #374151;
    letter-spacing: 1.5px;
    margin-bottom: 2px;
`;

export const TimerLabel = styled.div`
    font-family: "HelveticaW05Display", "Helvetica", sans-serif;
    font-size: 8px;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const TimerControls = styled.div`
    display: flex;
    gap: 6px;
    margin-bottom: 10px;

    > div {
        flex: 1;

        button {
            width: 100%;
            min-height: 32px !important;
            padding: 8px 12px !important;
            font-size: 12px;
        }
    }
`;

export const SmallButtonWrapper = styled.div`
    button {
        min-height: 32px !important;
        padding: 8px 12px !important;
        font-size: 12px;
    }
`;
